import api from '../api/api';

function detectTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

function localDateKey(tz) {
  try {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(new Date());
  } catch {
    return new Date().toISOString().slice(0, 10);
  }
}

let inflight = null;
let cached = null;
let cachedKey = null;

export async function loadPageADay({ force = false } = {}) {
  const tz = detectTimezone();
  const dateKey = localDateKey(tz);
  const cacheKey = `${tz}|${dateKey}`;

  if (!force && cached && cachedKey === cacheKey) {
    return cached;
  }
  if (!force && inflight && cachedKey === cacheKey) {
    return inflight;
  }

  cachedKey = cacheKey;
  inflight = api
    .get('/api/v1/pdf_parser/page-a-day/', {
      params: { tz },
    })
    .then(({ data }) => {
      cached = data;
      inflight = null;
      return data;
    })
    .catch((err) => {
      inflight = null;
      throw err;
    });

  return inflight;
}

export function clearPageADayCache() {
  cached = null;
  cachedKey = null;
  inflight = null;
}
